/* BK KARMA — поведение на секциите: табове, ленти за напредък, видеа, слайдове. */
(function () {
  if (window.bkKarmaLoaded) return;
  window.bkKarmaLoaded = true;

  function progress(root) {
    root.querySelectorAll('[data-bkk-rail]').forEach(function (rail) {
      var bar = rail.parentElement.querySelector('[data-bkk-progress] span');
      if (!bar || rail.dataset.bkkP) return;
      rail.dataset.bkkP = '1';
      function upd() {
        var max = rail.scrollWidth - rail.clientWidth;
        var w = rail.scrollWidth ? rail.clientWidth / rail.scrollWidth : 1;
        bar.parentElement.style.display = max > 4 ? '' : 'none';
        bar.style.width = (w * 100) + '%';
        var x = max > 0 ? (rail.scrollLeft / max) * (1 - w) * 100 / w : 0;
        bar.style.transform = 'translateX(' + x + '%)';
      }
      rail.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
  }

  function tabs(root) {
    root.querySelectorAll('[data-bkk-tabs]').forEach(function (sec) {
      if (sec.dataset.bkkT) return;
      sec.dataset.bkkT = '1';
      var btns = sec.querySelectorAll('[role="tab"]');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (o) {
            var on = o === b;
            o.setAttribute('aria-selected', on ? 'true' : 'false');
            o.classList.toggle('is-active', on);
            var p = document.getElementById(o.getAttribute('aria-controls'));
            if (p) p.hidden = !on;
          });
          progress(sec);
          var p = document.getElementById(b.getAttribute('aria-controls'));
          var rail = p && p.querySelector('[data-bkk-rail]');
          if (rail) rail.dispatchEvent(new Event('scroll'));
        });
      });
    });
  }

  function videos(root) {
    var items = root.querySelectorAll('[data-bkk-ugc]');
    if (!items.length) return;
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target.querySelector('video');
        if (!v || e.target.dataset.bkkManual === 'paused') return;
        if (e.isIntersecting && e.intersectionRatio > 0.6) {
          var pr = v.play();
          if (pr && pr.catch) pr.catch(function () {});
        } else { v.pause(); }
      });
    }, { threshold: [0, 0.6, 1] }) : null;
    items.forEach(function (it) {
      if (it.dataset.bkkV) return;
      it.dataset.bkkV = '1';
      var v = it.querySelector('video');
      if (!v) return;
      v.muted = true; v.loop = true; v.playsInline = true;
      v.addEventListener('play', function () { it.classList.add('is-playing'); });
      v.addEventListener('pause', function () { it.classList.remove('is-playing'); });
      var btn = it.querySelector('.bkk-ugc__play');
      function toggle() {
        if (v.paused) { it.dataset.bkkManual = ''; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        else { it.dataset.bkkManual = 'paused'; v.pause(); }
      }
      if (btn) btn.addEventListener('click', toggle);
      v.addEventListener('click', toggle);
      if (io) io.observe(it);
    });
  }

  function slides(root) {
    root.querySelectorAll('[data-bkk-slides]').forEach(function (box) {
      if (box.dataset.bkkS) return;
      box.dataset.bkkS = '1';
      var track = box.querySelector('[data-bkk-track]');
      var dots = box.querySelectorAll('[data-bkk-dot]');
      if (!track || dots.length < 2) return;
      function cur() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
      function mark() { var i = cur(); dots.forEach(function (d, j) { d.setAttribute('aria-current', i === j ? 'true' : 'false'); }); }
      dots.forEach(function (d, j) { d.addEventListener('click', function () { track.scrollTo({ left: j * track.clientWidth, behavior: 'smooth' }); }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
      var auto = parseInt(box.dataset.bkkAuto || '0', 10);
      if (auto > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var t = setInterval(function () {
          if (!document.body.contains(track)) { clearInterval(t); return; }
          var n = (cur() + 1) % dots.length;
          track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
        }, auto * 1000);
        box.addEventListener('pointerdown', function () { clearInterval(t); }, { once: true });
      }
      mark();
    });
  }

  function hero(root) {
    var vids = root.querySelectorAll('video[data-bkk-autoplay]');
    if (!vids.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function run() {
      vids.forEach(function (v) {
        var vis = v.offsetParent !== null;
        if (vis && !reduce) {
          if (v.preload !== 'auto') v.preload = 'auto';
          if (v.paused) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        } else if (!v.paused) { v.pause(); }
      });
    }
    /* 28.10 seo: видеото тръгва след зареждането на страницата (load + 1 s, най-късно 5 s,
       или при първо докосване/скрол), за да не се бори с LCP. Дотогава се вижда постерът (снимка). */
    var started = false;
    function start() {
      if (started) return; started = true;
      run();
      var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(run, 200); });
    }
    if (root !== document || window.Shopify && Shopify.designMode) { start(); return; }
    if (document.readyState === 'complete') setTimeout(start, 1000);
    else window.addEventListener('load', function () { setTimeout(start, 1000); }, { once: true });
    setTimeout(start, 5000);
    ['pointerdown', 'scroll', 'keydown'].forEach(function (ev) { window.addEventListener(ev, start, { once: true, passive: true }); });
  }

  // BK 24.10 (stranici): бутоните на приложенията (Instafeed) с aria-label на английски → български
  var BK_ARIA = [[/^\s*previous( post)?\s*$/i, 'Предишна публикация'], [/^\s*next( post)?\s*$/i, 'Следваща публикация']];
  function ariaBg() {
    var apps = document.querySelectorAll('.shopify-app-block');
    if (!apps.length) return;
    function fix(scope) {
      scope.querySelectorAll('button[aria-label], a[aria-label]').forEach(function (el) {
        var l = el.getAttribute('aria-label');
        for (var i = 0; i < BK_ARIA.length; i++) { if (BK_ARIA[i][0].test(l)) { el.setAttribute('aria-label', BK_ARIA[i][1]); break; } }
      });
    }
    apps.forEach(function (a) {
      if (a.dataset.bkAria) return;
      a.dataset.bkAria = '1';
      fix(a);
      if ('MutationObserver' in window) {
        var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { fix(a); }, 150); }).observe(a, { childList: true, subtree: true });
      }
    });
  }

  function init(root) { root = root || document; tabs(root); progress(root); videos(root); slides(root); hero(root); ariaBg(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
